import React, { useState, useRef, useEffect } from "react";
import { IconFileUpload, SecondaryButton, Input, Divider } from "cdk-radial";
import "./styles.css";
import {CSV_FILE} from '../../src/Utils/constants'

const UploadCSVFiles = (props) => {
  const {FeeWaiverManagementReducer, uploadAppApiIntegrationCSV, uploadSubscriptionOrganisationCSV, auth } =
    props;

  const {uploadingAppApiIntegration, uploadingSubscriptionOrganisation} = FeeWaiverManagementReducer;
  const [appApifile, setAppApiFile] = useState(null);
  const [subscriberOrgFile, setSubscriberOrgFile] = useState(null);
  const [appApiFileError, setAppApiFileError] = useState("");
  const [subscriberOrgFileError, setSubscriberOrgFileError] = useState("");
  const inputAppApiFileRef = useRef();
  const inputSubscriberOrgFileRef = useRef();

  const validateAppApiFile = (file) => {
    if (!file) {
      setAppApiFileError("No file selected");
      return false;
    }
    if (/\s/.test(file.name)) {
      setAppApiFileError("File name should not contain spaces");
      return false;
    }
    if (file.name !== "app-api-integrations.csv") {
      setAppApiFileError("File name should be app-api-integrations");
      return false;
    }
    setAppApiFileError("");
    return true;
  };

  const handleAppApiFileChoose = (e) => {
    const isClick = e.type === 'click';
    const isEnter = e.key === 'Enter' || e.keyCode === 13;
    const isSpace = e.key === 'Space' || e.keyCode === 32;
    if (isClick || isEnter || isSpace) {
      inputAppApiFileRef.current.click();
    }
  }

  const handleSubscriberOrgChoose = (e) => {
    const isClick = e.type === 'click';
    const isEnter = e.key === 'Enter' || e.keyCode === 13;
    const isSpace = e.key === 'Space' || e.keyCode === 32;
    if (isClick || isEnter || isSpace) {
      inputSubscriberOrgFileRef.current.click();
    }
  }

  const validateSubscriberFile = (file) => {
    if (!file) {
      setSubscriberOrgFileError("No file selected");
      return false;
    }
    if (/\s/.test(file.name)) {
      setSubscriberOrgFileError("File name should not contain spaces");
      return false;
    }
    if (file.name !== "subscriber-organizations.csv") {
      setSubscriberOrgFileError("File name should be subscriber-organizations");
      return false;
    }
    setSubscriberOrgFileError("");
    return true;
  };

  const handleAppApiFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (validateAppApiFile(selectedFile)) {
      setAppApiFile(selectedFile);
      handleAppApiIntegrationUpload(selectedFile);
    } else {
      setAppApiFile(null);
    }
  };

  const handleSubscriberOrgFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (validateSubscriberFile(selectedFile)) {
      setSubscriberOrgFile(selectedFile);
      handleSubscriberOrgUpload(selectedFile)
    } else {
      setSubscriberOrgFile(null);
    }
  };

  const handleAppApiIntegrationUpload = (selectedFile) => {
    const formData = new FormData();
    formData.append("resourceFile", selectedFile);
    uploadAppApiIntegrationCSV({
      accessToken: auth.accessToken,
      formData,
    });
  };

  const handleSubscriberOrgUpload = (selectedFile) => {
    const formData = new FormData();
    formData.append("resourceFile", selectedFile);
    uploadSubscriptionOrganisationCSV({
      accessToken: auth.accessToken,
      formData,
    });
  };

  useEffect(() => {
    if (appApifile && !uploadingAppApiIntegration) {
      inputAppApiFileRef.current.value = ''
    }
  }, [uploadingAppApiIntegration]);

  useEffect(() => {
    if (subscriberOrgFile && !uploadingSubscriptionOrganisation) {
      inputSubscriberOrgFileRef.current.value = ''
    }
  }, [uploadingSubscriptionOrganisation]);

  return (
    <div className="upload-csv-container">
      <div className="file-selector-section">
        <FileInput 
          id={CSV_FILE.APP_API_INTEGRATION_ID}
          label={CSV_FILE.APP_API_INTEGRATION_FILE_NAME}
          file={appApifile}
          fileError={appApiFileError}
          fileRef={inputAppApiFileRef}
          handleChoose={handleAppApiFileChoose}
          handleFileChange={handleAppApiFileChange}
        />
        <Divider style={{width: '440px'}} data-testid="divider" />
        <FileInput 
          id={CSV_FILE.SUBSCRIBER_ORGANIZATION_ID}
          label={CSV_FILE.SUBSCRIBER_ORGANIZATION_FILE_NAME}
          file={subscriberOrgFile}
          fileError={subscriberOrgFileError}
          fileRef={inputSubscriberOrgFileRef}
          handleChoose={handleSubscriberOrgChoose}
          handleFileChange={handleSubscriberOrgFileChange}
        />
      </div>
    </div>
  );
};


const FileInput = ({
  label,
  id,
  file,
  fileError,
  fileRef,
  handleChoose,
  handleFileChange,
}) => (
  <>
    <div className="file-selection">
      <div className="file-selection-section">
        <div className="file-selection-sub-header">Upload {label} File</div>
        <div className="file-selection-input">
          <div className="file-selection-input-box">
            <Input
              id={`${id}-input`}
              label={id+'s.csv'}
              name={`input-${id}`}
              value={file ? file.name : ""}
              onClick={handleChoose}
              onKeyUp={handleChoose}
              onChange={handleChoose}
              readOnly
              enableCustomValidation
              errorMessage={fileError}
              hasError={fileError !== "" ? true : false}
            />
            <input
              style={{ display: "none" }}
              ref={fileRef}
              type="file"
              accept=".csv,text/csv"
              data-testid={`id-${id}`}
              onChange={handleFileChange}
            />
          </div>
          <div className="file-selection-input-button">
            <SecondaryButton
              icon={<IconFileUpload />}
              text="Choose File"
              onClick={() => {
                fileRef.current.click();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  </>
);

export default UploadCSVFiles;
